import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { FileText, Trash2 } from "lucide-react";

interface IdCardItemProps {
  id: string;
  uploadDate: string;
  onDownload: () => void;
  onDelete: () => void;
}

export const IdCardItem = ({ id, uploadDate, onDownload, onDelete }: IdCardItemProps) => {
  return (
    <Card className="p-6 bg-white shadow-sm hover:shadow-md transition-all duration-200 rounded-xl border border-gray-200">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="p-2 bg-[#F1F0FB] rounded-lg">
            <FileText className="h-6 w-6 text-[#9b87f5]" />
          </div>
          <div>
            <h3 className="font-medium text-gray-900">ID Card</h3>
            <p className="text-sm text-gray-500">
              Uploaded {new Date(uploadDate).toLocaleDateString()}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Button 
            variant="ghost"
            onClick={onDownload}
            className="hover:bg-[#F1F0FB] hover:text-[#9b87f5] transition-colors"
          >
            Download
          </Button>
          <Button
            variant="ghost"
            onClick={onDelete}
            className="hover:bg-red-50 hover:text-red-600 transition-colors"
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </Card>
  );
};